// extracted by mini-css-extract-plugin
module.exports = {"poweredBySanna":"styles_poweredBySanna__3a9Vr"};